import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
} from 'reactstrap';
import Input from '../../Input';
import DosagesSelect from '../../DosagesSelect';

class DrugsAndDosages extends React.PureComponent {
  render() {
    const { validation, selectedFormularySite, values } = this.props;
    return (
      <Row className="px-5 py-3 fade-in">
        <Col className="col-6">
          <Input id="site_url" label="Site Specific URL:" value={selectedFormularySite} disabled />
          <Input
            category="drugs"
            categoryType="array"
            pattern={validation.drug_name_display}
            label="Display of Drug Name:"
            value={values.drugs ? values.drugs[0] : null}
          />
          {/* <Input id="drug_id" label="Drug ID:" />
          <Input
            id="commonDosage"
            label="Default Dosage:"
          /> */}
          <DosagesSelect id="commonDosage">Dosages:</DosagesSelect>
        </Col>
        <Col />
      </Row>
    );
  }
}

const mapStateToProps = (store) => ({
  validation: store.theme.validation,
  selectedFormularySite: store.sites.selectedFormularySite,
  values: store.sites.values,
});

export default connect(mapStateToProps)(DrugsAndDosages);
